module.exports = {
  // 头部
  hd: {
    login: 'Login',
    register: 'Register',
    announcement: 'Announcement',
    game: 'Game',
    otc: 'OTC',
    capital: 'Asset',
    transaction: 'OTC',
    currency: 'EXCHANGE',
    currencyMall: 'EXCHANGE CENTER',
    co: 'CONTRACT',
    coCenter: 'CONTRACT CENTER',
    home: 'HOME',
    userCenter: 'Account',
    orderManage: 'Orders',
    apiManage: 'My API',
    ask: 'Question',
    logout: 'Logout',
    chaindown: 'Cooperation',
    economic: 'Economic',
    adcenter_def: 'Buy/Sell',
    adcenter_big: 'Block Trade',
    mining: 'MINING TRANSACTION',
    invitation: 'INVITATION LINK',
    msgcenter: 'Message',
    set: 'Set',
    otc_trade: "OTC Trade",
    c2c_trade: "C2C Trade"
  },
  // 底部
  ft: {
    tickets: "Tickets",
    partners: "Partners",
    weibo: "Weibo",
    qqgroup: "QQ Group",
    telegram: "Telegraph Group",
    email: "Email",
    facebook: "Facebook",
    whitepapers: "White Paper",
  },
  main: {
    description: "Description",
    fbdw: 'Unit',
    marketSet: 'Self-Select',
    more: 'More',
    allMarkets: "All",
    search: 'Search',
    market: 'Market',
    close: 'Lalest Price',
    rose: 'Change',
    height: 'Highest Price',
    low: 'Lowest Price',
    vol: 'Deal Volume',
    amount: 'Amount',
    no_data: 'No data',
    prompt: 'Reminder: digital assets are innovative capital products, their price not stable and there’s high risks, please be aware of the risks before you make any decisions.',
    notice: 'Notice',
    deal_forehead: 'Turnover',
    loading_ing: 'Loading...',
    theme: 'Theme',
    copy: "Copy",
    blueTheme: 'Blue Theme',
    whiteTheme: 'White Theme',
    blackTheme: 'Black Theme',
    exchangeApp: "Exchange APP",
    exchangeAppIntroduce: "Fast and convenient whole network trading platform",
    bipayApp: "BiPay APP",
    bipayAppIntroduce: "Payment, games, applications and other integrated wallet",
    app_download: 'APP Download',
    app_01: "Fast, convenient and safe trading platform",
    app_ios: "IOS Download",
    app_ios_01: "Please click me to trust again and install",
    app_android: "Android Download",
    app_h5: "H5 Address",
    sweep_download: 'Download',
    download_address: "Download address",
    download_page: "download page",
    copySuccess: "Copy Success",
    getCode: "Get Code",
    confirm: "Confirm",
    cancel: "Cancel",
    noData: "No Data",
    viewMore: "View More",
    ReleaseTime: "Release time",
    notNull: "parameter cannot be null",
    sureDel: "Are you sure to delete it",
    close_01: "Close",
    NotOpen: "Not yet open",
    pleaseLogin: "Please log in",
    serverException: "Server exception",
    unknown: "unknown",
    alert_01: "Click on the top right corner",
    alert_02: "button",
    alert_03: "select",
    alert_04: "Open it in Safari",
    alert_05: "Open it in a browser",
    optional: "optional",
  },
  user: {
    announcement: 'announcement',
    userCenter: 'user center',
    langSetting: 'language setting',
    securityCenter: 'security center',
    versionUpdates: 'version updates',
    monetaryUnitSetting: 'monetary unit setting',
    currencySet: 'currency set',
    aboutUs: 'about us',
    share: 'share',
    loginRegister: 'login/register',
    logout: 'Logout',
    money: "Money",
    deal: "Deal",
    myOrder: "My Order",
    dealHistory: "Deal History",
    lock: "Lock",
    lockHistory: "Lock History",
    releaseHistory: "Release History",
    financial: "Financial",
    certification: "Certification",
    security: "Security",
    recommended: "Recommended",
    workorder: "Work order",
    bankcard: "Bank card",
    personal: 'Personal center',
  },
  // 首页
  home: {
    next: 'Next',
    favorites: "Favorites",
    markets: "Markets",
    performer: 'performer',
    DropList: 'DropList',
    transferAccounts: 'transfer accounts',
    ExpertsToShare: 'Experts to Share',
    service: 'service',
    share: 'share',
    SaveMoneyLive: "Save money live",
    CurrencyTraders: 'Currency traders',
    experienceImmediately: 'experience immediately',
    shares: 'After login can share oh',
    copysuc: 'Share link copied successfully',
    nonsupport: 'The browser does not support automatic replication',
    classify: "classify",
    text_01: "After opening, you can select currency classification, close to restore the default list"
  },
  // 交易中心
  trade: {
    latestPrice: 'Price',
    highestPrice: 'High',
    minimumPrice: 'Low',
    applies: 'Change',
    H_volume: '24H Volume',
    H_turnover: '24H Amount',
    K_line: 'K-line',
    depth_line: 'Depth ',
    LoginAccount: 'Login',
    liquidity: 'Allow asset liquidity',
    totalAssets: 'Estimated Net Value',
    marketSet: 'Markets',
    searchSymbols: 'Search',
    symbols: 'Coin',
    noSymbols: 'No Coin',
    latestDeal: 'Last Price',
    coin: "Coin",
    time: 'Time',
    price: 'Price',
    amount: 'Amount',
    money_01: "money",
    dealVolume: 'Volume',
    trade_01: "Trade right, wrong price, success will not be canceled.",
    trade_02: "Warning: currently is",
    order: "order",
    dealAmount: "Deal Amount",
    action: "Action",
    maker: "Maker",
    taker: "Taker",
    type: "Type",
    buy: 'BUY',
    sell: 'SELL',
    buy_d: 'Buy',
    sell_d: 'Sell',
    available: 'Available',
    marketPrice: 'Market Order',
    limitPrice: 'Limit Order',
    mergeDepth: 'Merge depth',
    total: 'Total',
    dealDepth: 'deal depth',
    buyDepth: 'Buying depth',
    sellDepth: 'Selling depth',
    entrustTime: 'Time',
    entrustType: 'Type',
    entrustPrice: 'Price',
    entrustNumber: 'Volume',
    entrustMoney: 'Total',
    dealMoney: 'Total',
    averagePrice: 'Average price',
    notDeal: 'Unexecuted',
    orderSource: 'Order source',
    status_c: 'Status/Action',
    cancelOrder: 'Revoke',
    notData: 'No data',
    confirmCancelText: 'Confirm withdrawing order?',
    cancel: 'Cancel',
    confirm: 'Confirm',
    myOrder: 'My order',
    myDeal: "My Deal",
    allOrder: 'All orders',
    dealHistory: 'Order history',
    c_success: 'Operation success',
    mPriceBuy: 'Buy at the best market price',
    mPriceSell: 'Sell at the best market price',
    money: 'Amount',
    buyPrice: 'Buy Price',
    buyNumber: 'Buy Qty',
    buyMoney: 'Buy volume',
    sellPrice: 'Sell price',
    sellNumber: 'Sell Qty',
    sellMoney: 'Sell Amount',
    fillError: 'Input error',
    dealFw: 'amount exceed limit',
    dealCussess: 'Success',
    dealId: 'ID',
    dealTime: 'Time',
    dealMoneys: 'Volume',
    dealPrice: 'Price',
    serviceCharge: 'Fee',
    tradeFee: "Trade Fee",
    errorInfor_1: 'Please login',
    errorInfor_2: 'Account information',
    errorInfor_3: 'No Available',
    errorInfor_4: 'Please deposit',
    selectPair: "Select pair",
    gains: "gains",
    drop: "drop",
    exit: "exit",
    text_01: "Clinch a deal just accept, withdraw sheet to return. The deduction of the actual transaction shall prevail",
    text_02: "Are you sure to cancel?",
    text_03: "It can't be less than 0",
    cancelSuccess: "Cancel success",
    cannotBeZero: "Cannot be zero"
  },
  // 行情
  market: {
    main: "Main",
    next: "Next",
    currency: 'currency',
    price: 'latest price',
    increase: 'increase',
    market: 'market',
    optionalArea: 'optional area',
    loadingLoad: 'loading load',
    noData: 'no data',
    "LIMIT_TRADE_BTC": "Trading at least 0.001 BTC",
    "LIMIT_TRADE_C2C": "Trading at least 70 C2C",
    "LIMIT_TRADE_ETH": "Trading at least 0.01 ETH",
    "LIMIT_TRADE_USDT": "Trading at least 10 USDT",
    "LIMIT_TRADE": "No small orders"
  },
  // 交易所
  exchange: {
    huobi: "HUOBI",
  },
  // 钱包
  wallet: {
    Rebind: "Rebind",
    Account: "Account",
    BindAccount: "Bind Account",
    AccountType: "Account Type",
    bind_success: "Dind Success",
    "TimeMachine": "Time machine",
    StarCraftCapsule: "StarCraft capsule",
    "TransferHistory": "Transfer history",
    bind_text01: "Unbound account, please bind",
    walletAccount: "Wallets",
    tradeAccount: "Trade account",
    fiatAccount: "Fiat account",
    gameAccount: "Game account",
    EstimatedBalance: "Estimated Balance:",
    myWallet: 'my wallet',
    toLogin: 'to login',
    noLogin: 'you not login',
    assetValuation: 'assetValuation',
    search: 'Search',
    usable: 'usable',
    available: "Available",
    freeze: "Freeze",
    total: "Total",
    price: "Price",
    action: "Action",
    lock: 'lock',
    trade: "trade",
    candy: "candy",
    give: "give",
    Referral: "Referral bonuses",
    into: "into",
    RollOut: "Roll out",
    buy: "buy",
    sell: "sell",
    wallet: "wallet",
    deposit: 'Deposit',
    MentionMoney: 'MentionMoney',
    withdraw: "Withdraw",
    deal: 'Deal',
    transfer: 'Transfer',
    hideBalance: "Hide balance of 0",
    depositAddress: "Deposit Address",
    minDeposit: "Min Deposit",
    address: "address",
    amount: "amount",
    selectCategory: "Select the category",
    selectCoin: "Select coin",
    startDate: "Start date",
    to: "to",
    endDate: "End date",
    query: "query",
    category: "Category",
    otherAccount: "other account",
    submitSuccess: "submit successfully",
    transferSuccess: "Transfer success",
    Transfer: "Transfer",
    Transfers: "Transfers",
    TransferCoin: "Transfer coin",
    TransferAmount: "Transfer amount",
    Maximum: "Maximum:",
    From: "From",
    To: "To",
    TransferSuccess: "Transfer success",
    Transfer_01: "Exceed the available amount.",
    Transfer_02: "Unsupported swivel mode",
    valuation: "valuation",
    serviceFee: "service fee",
    chain_name: "Chain name",
  },
  // 交易
  buy: {
    price: 'price',
    amount: 'amount',
    rental: 'rental',
    availableBalance: 'available balance:',
    AllWarehouse: 'AllWarehouse',
    AWarehouse: 'AWarehouse',
    warehouse: 'warehouse',
    buy: 'buy',
    sale: 'sale',
    TransactionsAreNotAllowedInThisCurrency: 'Transactions areNot allowed in this currency',
    sell: 'sell',
    purchase: 'purchase',
    type: 'type',
    turnover: 'turnover',
    hint: 'hint',
    confirm: 'confirm',
    cancel: 'cancel',
    CommissionedByTheCurrent: 'Commissioned by the current',
    BidHistory: 'Bid History'
  },
  // 登录|注册|找回密码
  login: {
    welcomeLogin: 'Login',
    welcomeRegister: 'Register',
    noAccount: 'Do not have an account?',
    isAccount: 'Existing account?',
    register: 'Register',
    phoneOrEmail: "Phone number or Email address",
    code: "code",
    login: 'Login',
    loginIng: 'Logging in',
    registerIng: 'Registering',
    submitIng: 'Submitting',
    switchimg: "Switch the picture",
    resend: " Refetch after seconds",
    allNationalities: "All nationalities",
    commonlyUsed: "Frequently Used",
    forgetPassword: 'Forget password',
    passwordResetS: "Password reset successful",
    cancel: 'Cancel',
    confirm: 'Confirm',
    password: 'Password',
    loginCuccess: 'Login success',
    registerCuccess: 'Register success',
    registerMobile: "Phone",
    registerEmail: "Email",
    phoneNumber: "Phone Number",
    text_01: 'Register with phone number',
    text_02: 'Register with email address',
    text_03: 'I have read and agreed',
    text_04: 'Terms of service',
    text_05: 'Privacy protection',
    text_06: 'Please read and agree with terms of service',
    text_07: 'Please enter a 8-16 digit password including number and letters.',
    text_08: 'Nationality cannot be revised after registration!',
    text_09: "Email",
    text_10: "parameter cannot be null",
    confirmPassword: 'Confirm password',
    retrievePas: 'Retrieve password',
    phoneRetrieve: 'Retrieve phone number',
    emailRetrieve: 'Retrieve email address',
    lastStep: 'Last step',
    nextStep: 'Next step',
    pasSetCuc: 'Password setting completed.',
    error_500: 'Server failure, please try again later',
    verification: 'Verification method',
    default: 'Use the default verification method',
    email: 'E-mail verification',
    phone: 'Phone verification',
    google: 'Google verification',
    retpass: 'Retrieving password',
    inputcorrect: 'Please enter the correct email or mobile phone number',
    inputnull: 'Please enter email or mobile phone number',
    inputcode: 'Please enter the verification code',
    inputcodeerror: 'Error in captcha input',
    newpass: 'new password',
    passnull: 'The password cannot be empty',
    chars: 'Please enter your password with 8-20 non - white space characters',
    surepass: 'confirm password',
    againpass: 'Please enter your password again',
    nopass: 'The passwords entered are inconsistent',
    forgots: 'retrieve password',
    changepass: 'Password changed successfully',
    perfect: 'Please complete the information.',
    signs: 'Sign up for a new member account',
    userName: 'Please create a user name',
    signaccount: 'registered account',
    send: 'send',
    codenull: 'Please enter the verification code',
    setpass: 'Please set your login password',
    referrer: 'Referral Code',
    mustreferrer: 'Referral Code (required)'
  },
  // 找回密码
  forgot: {
    retpass: 'Retrieving password',
    inputcorrect: 'Please enter the correct email or mobile phone number',
    inputnull: 'Please enter email or mobile phone number',
    inputcode: 'Please enter the verification code',
    newpass: 'new password',
    passnull: 'The password cannot be empty',
    chars: 'Please enter your password with 8-20 non - white space characters',
    surepass: 'confirm password',
    againpass: 'Please enter your password again',
    nopass: 'The passwords entered are inconsistent',
    forgots: 'retrieve password',
    changepass: 'Password changed successfully',
    perfect: 'Please complete the information.'
  },
  // 注册
  sign: {
    chars: 'Please enter your password with 8-20 non - white space characters',
    userName: 'Please create a user name',
    usernameerror: "Please enter 3-20 non-white space characters",
    inputnull: 'Please enter email or mobile phone number',
    signs: 'Sign up for a new member money',
    name: 'Please enter a user nickname',
    signaccount: 'registered money',
    send: 'send',
    codenull: 'Please enter the verification code',
    setpass: 'Please set your login password',
    referrer: 'Referral Code (not required)',
    mustreferrer: 'Referral Code (required)',
    referrernull: "Referral Code cannot be empty",
    inputcorrect: 'Please enter the correct email or mobile phone number',
    inputcode: 'Please enter the verification code',
    newpass: 'new password',
    passnull: 'The password cannot be empty',
    surepass: 'confirm password',
    againpass: 'Please enter your password again',
    nopass: 'The passwords entered are inconsistent',
    forgots: 'retrieve password',
    changepass: 'Password changed successfully',
    inputcodeerror: 'Error in captcha input',
  },
  // c2c交易
  c2c: {
    "PLEASE_VERIFY_YOUR_REALNAME": "Please verify your realname",
    deal: 'deal',
    tradingRecord: 'tradingRecord',
    need: 'need',
    price: "Price",
    amount: "Amount",
    time: 'Time',
    action: "Action",
    type: "type",
    orderID: "OrderID",
    ToBuyImmediately: 'BUY',
    acquirability: 'acquirability',
    ImmediatelySell: 'SELL',
    purchases: 'purchases',
    BuyQuantity: 'Buy quantity',
    SellQuantity: 'Sell quantity',
    TradeShow: 'Trade Show',
    explain_1: 'The merchants for sale and purchase are all on-site inspection and certification merchants, and provide 1 million USDT deposit. Each time you trade, you will freeze the assets of the merchants. If the assets of the merchants are not enough, you cannot accept orders, and you can be assured to trade',
    explain_2: 'The merchants are real-name verified merchants, and provide security deposit, can be assured of conversion',
    explain_3: 'Please use the bank card with which you bind to make the remittance. Any other remittance will be refunded. (WeChat and alipay is prohibited)',
    explain_4: 'Orders with non-processing time will be processed from 9:00 a.m. to 21:00 p.m. the next day. Generally, payment will be made within 24 hours after receiving orders',
    explain_5: 'A maximum of 5 pending recharge orders can be initiated in a single day。',
    unitPrice: 'unitPrice',
    paymentInformation: 'paymentInformation',
    moneyOrder: 'moneyOrder',
    success: 'success',
    unfinished: "unfinished",
    unconfirmed: "unconfirmed",
    canceledCanc: 'canceledCanc',
    inhand: 'inhand',
    haveExpired: 'haveExpired',
    unpaid: 'unpaid',
    name: 'Name of beneficiarys money',
    oBnak: 'The receiver opens the bank',
    number: 'Beneficiarys money number',
    txt: 'Remarks on remittance',
    must: '(Please fill in)',
    mobile: 'The receivers mobile phone number',
    HaveTransfer: 'HaveTransfer',
    cancel: 'cancel',
    back: 'back',
    CancelWithdrawal: 'Cancel',
    ToTransfer: 'ToTransfer',
    overdue: 'overdue',
    service: 'Name of service provider',
    snum: 'Service phone number',
    fBnak: "Facilitator bank",
    fNumber: "Facilitator money number",
    tacount: 'transfer amount',
    state: "state",
    ordercancel: 'The order has been cancelled.',
    orderdispose: 'The order has been submitted for processing',
    copysuccess: 'Copy success',
    surecancel: 'Are you sure you want to cancel?',
    depositsuccess: 'Withdrawal is successful, please wait for the service provider to process',
    untreated: 'untreated',
    orderInformation: "order information",
    text_01: "quantity must not exceed the balance",
    text_02: "Please remit to the seller according to the prompt information",
    text_03: "(prohibit the use of alipay and WeChat)",
    remark: "Transfer remark",
    required: "required",
    WaitingTransfer: "Waiting transfer",
    ServiceProvider: "Service provider",
    buy_text01: "You can only enter multiples of 100"
  },
  otc: {
    AppealedOrders: "Appealed Orders",
    report: "Report",
    openOtc: "Open OTC",
    otcRules: "Conditions for applying to open OTC",
    buy: 'Buy',
    sell: 'Sell',
    lastPrice: "Last Price",
    high: "High",
    low: 'Low',
    merchant: "Merchant",
    merchantList: "Merchant list",
    orderList: "Order List",
    tradePrice: "price",
    buyByAmount: "BuyByAmount",
    buyByVol: "BuyByVol",
    sellByAmount: "SellByAmount",
    sellByVol: "SellByVol",
    buyPl: "请输入购买总额",
    prompt_01: "It must be paid out of my own account",
    availableBalance: "Available Balance",
    paymentMethod: "Payment Method",
    PaymentCollection: "PaymentCollection",
    bankTransfer: "Bank Transfer",
    alipay: "Alipay",
    weixin: "WeChat",
    tradeOrder: "Buy/Sell",
    t_seller: "Seller",
    limits: "Limits",
    trade: "Trade",
    t_buy: "Buy",
    t_sell: "Sell",
    minimumAmount: "minimum Amount",
    maxmumAmount: "maxmum Amount",
    fee: "Fee",
    total: 'Total',
    order_text01: "Buyer account information",
    order_text02: "Please choose the following method to pay the seller",
    order_text03: "Do not note 'Bitcoin', 'virtual currency' and other information please pay attention to the other party's real name is consistent",
    confirmationReceipt: "Confirmation of receipt",
    order_text04: "Confirm to do the following for the order?",
    order_text06: "Please confirm that you have received the corresponding payment. After the operation, the fund will be directly transferred to the other party. There is a risk of non-recovery.",
    order_text05: "Be sure to check to see if the appropriate payment has been received",
    order_text07: "Please contact customer service to get it",
    confirmPayment: "Confirm payment",
    waiting_process: "waiting process",
    true_name: "Real Name",
    importantNote: "Important note",
    paymentAmount: "Payment Amount",
    amountCollected: "Amount Collected",
    accountNumber: " Number",
    realName: "realName",
    confirmCreate: "Confirm to create",
    failure: "Failure",
    partialSuccess: "Partial Success",
    forThePayment: "For the payment",
    paymentHasBeen: "Payment has been",
    forCollection: "For collection",
    confirmReceipt: "Confirm receipt",
    error_01: "No more than quantity",
    error_02: "Minimum amount No more than Maximum amount",
    dealOrders: "Deal Orders",
    currentOrder: "Current order",
    merchantOrder: "Merchant order",
    completedOrder: "Completed order",
    cancelledOrder: "Cancelled order",
    buyer: "buyer",
    seller: "seller",
    moneyTotal: "Total",
    title_01: "please confirm",
    text_04: "The actual order shall prevail",
    text_05: "Way to trade",
    text_06: "Confirm the order",
    text_07: "Apply  merchant",
    text_08: "select payment",
    apply: "apply",
    text_09: "Apply to become a merchant condition",
    text_10: "User accounts must be approved",
    text_11: "User accounts must be bound",
    allPay: "All payment method",
    pleaseEnter: "please enter",
    "PLEASE_VERIFY_YOUR_REALNAME": "Please verify your realname",
    deal: 'deal',
    tradingRecord: 'tradingRecord',
    need: 'need',
    price: "Price",
    amount: "Amount",
    time: 'Time',
    action: "Action",
    type: "type",
    orderID: "ID",
    ToBuyImmediately: 'BUY',
    acquirability: 'acquirability',
    ImmediatelySell: 'SELL',
    purchases: 'purchases',
    BuyQuantity: 'Buy quantity',
    SellQuantity: 'Sell quantity',
    TradeShow: 'Trade Show',
    explain_1: 'The merchants for sale and purchase are all on-site inspection and certification merchants, and provide 1 million USDT deposit. Each time you trade, you will freeze the assets of the merchants. If the assets of the merchants are not enough, you cannot accept orders, and you can be assured to trade',
    explain_2: 'The merchants are real-name verified merchants, and provide security deposit, can be assured of conversion',
    explain_3: 'Please use the bank card with which you bind to make the remittance. Any other remittance will be refunded. (WeChat and alipay is prohibited)',
    explain_4: 'Orders with non-processing time will be processed from 9:00 a.m. to 21:00 p.m. the next day. Generally, payment will be made within 24 hours after receiving orders',
    explain_5: 'A maximum of 5 pending recharge orders can be initiated in a single day。',
    unitPrice: 'unitPrice',
    paymentInformation: 'paymentInformation',
    moneyOrder: 'moneyOrder',
    success: 'success',
    unfinished: "unfinished",
    unconfirmed: "unconfirmed",
    canceledCanc: 'canceledCanc',
    inhand: 'inhand',
    haveExpired: 'haveExpired',
    unpaid: 'unpaid',
    name: 'Name of beneficiarys money',
    oBnak: 'The receiver opens the bank',
    number: 'Beneficiarys money number',
    txt: 'Remarks on remittance',
    must: '(Please fill in)',
    mobile: 'The receivers mobile phone number',
    HaveTransfer: 'HaveTransfer',
    cancel: 'cancel',
    back: 'back',
    CancelWithdrawal: 'Cancel',
    ToTransfer: 'ToTransfer',
    overdue: 'overdue',
    service: 'Name of service provider',
    snum: 'Service phone number',
    fBnak: "Facilitator bank",
    fNumber: "Facilitator money number",
    tacount: 'transfer amount',
    state: "state",
    ordercancel: 'The order has been cancelled.',
    orderdispose: 'The order has been submitted for processing',
    copysuccess: 'Copy success',
    surecancel: 'Are you sure you want to cancel?',
    depositsuccess: 'Withdrawal is successful, please wait for the service provider to process',
    untreated: 'untreated',
    orderInformation: "order information",
    text_01: "quantity must not exceed the balance",
    text_02: "Please remit to the seller according to the prompt information",
    text_03: "(prohibit the use of alipay and WeChat)",
    remark: "Transfer remark",
    required: "required",
    WaitingTransfer: "Waiting transfer",
    ServiceProvider: "Service provider",
    buy_text01: "You can only enter multiples of 100"
  },
  // 安全中心
  security: {
    LoginPasswordSetting: 'LoginPasswordSetting',
    Certification: 'Certification',
    GoogleCertification: 'GoogleCertification',
    PaymentOfTheBinding: 'PaymentOfTheBinding',
    verificationMode: 'verificationMode',
    BindingMobilePhone: 'BindingMobilePhone',
    change: "Change ",
    text_01: "Please enter email address",
    text_02: "Please enter the correct email address",
    bind: "Bind ",
    oldPassword: "old password",
    newPassword: "new password",
    oldpayPassword: "Old Pay Password",
    newpayPassword: "New Pay Password",
    confirmPassword: "Confirm password",
    payPassword: "Pay Password",
    confirmPayPassword: "Confirm Pay Password",
    payPasswprd_01: "Please enter your fund password",
    payPasswprd_02: "Please enter your six - digit pure - digit fund password",
    payPasswprd_03: "In order to ensure the security of funds, please enter the fund password when setting the transaction",
    setSuccess: "Set Success",
    email: "email",
    mobile: "mobile",
    password: "password",
    email_text: "The email you bind to is",
    mobile_text: "Your mobile phone number is",
    password_text: "Use when logging in",
    email_text_01: "You are not bound to mailbox",
    mobile_text_01: "You are not bound to the mobile phone number",
    avatar: "Avatar",
    gender: "gender",
    man: "man",
    woman: "woman",
    secret: "secret",
    immediatelyChange: "Immediately change",
    modifySuccess: "Modify the success",
    upload_text01: "Upload images can only be JPG, JPEG, GIF, BMP, PNG format!",
    username: "User Name",
  },
  // 密码验证
  password: {
    changePassword: 'change password',
    PleaseEnterANewPassword: 'Please enter a new password',
    ConfirmNewPassword: 'ConfirmNew password',
    resetPasswords: 'reset passwords',
    passwordCannot: 'The password cannot be less than 8 bits',
    DifferentPasswords: 'Different passwords',
    passwordEmpty: 'The password cannot be empty'
  },
  // 实名认证
  certification: {
    id_card: "ID Card",
    Certification: 'Certification',
    ordinaryCertification: "Ordinary certification",
    identity: "Identity",
    identityContent: "Please perfect the identity authentication",
    senior: "Senior",
    seniorContent: "Please perfect the advanced certification",
    senior_1: "Please complete the identity authentication first and then proceed to the advanced authentication",
    attestation: "attestation",
    certified: "Certified",
    Credentials: 'Information',
    inthereview: "In the review",
    results: "results",
    hint: 'Upload the front and back of your id card (please make sure the content of your photo is complete and clearly visible, and your id card must be valid). Holding his id card front photo and personal signature, personal signature of the content included',
    realNames: 'Real name',
    IDType: "ID Type",
    validID: 'Id card',
    uploading: 'Upload id information (please make sure it is clearly visible)',
    frontCard: 'Front of id card ',
    versoCard: 'Reverse side of id card',
    handCard: 'Holding an id card)',
    signature: 'And the current date (please make sure your photo and signature are clearly visible).',
    submit: 'Submit the certification',
    AuditFailed: 'Audit failed',
    cause: 'cause',
    revalidate: 'revalidate',
    audit: 'Real name is under review......',
    pass: 'You have been authenticated by your real name',
    frontCardFailToUpload: 'Id card front upload failed',
    versoCardFailToUpload: 'Id card reverse upload failed',
    handCardFailToUpload: 'Failed to upload id card',
    realName: 'Please enter your real name',
    IDCard: 'Please enter your id card number',
    await: 'Wait for the picture to be uploaded',
    submitSuccessfully: 'submit successfully',
    text_01: "Congratulations, you have completed the real-name authentication",
    text_02: "Your materials have been submitted for review, which is expected to be completed within one working days",
    text_03: "We will protect your personal information security, please be patient!",
    text_04: "Congratulations, you've completed your advanced certification",
    text_05: "Incomplete information",
    step1: "Upload a valid certificate",
    step2: "Waiting for audit",
    step3: "Authentication success",
    pRequire: "photo require",

  },
  // 谷歌认证
  Google: {
    otp: "Google Authentication",
    unverified: "unverified",
    certified: "certified",
    authentication: 'authentication',
    copy: 'Copy',
    gcode: 'Please enter the Google verification code',
    gopen: 'Enable Google authentication',
    turned: 'You have turned on Google validation',
    change: 'change',
    gvcode: 'Google verification code',
    gcancel: 'Cancel Google validation',
    gnull: 'The Google verification code cannot be empty',
    pnull: 'The password cannot be empty',
    gerr: 'Google verification code error',
    perr: 'wrong password',
    bindSuccess: "Google verification binding succeeded",
    unBindSuccess: "Unbind successfully",
    GoogleDownload: "Download the Google validator",
    key: "key:",
    step1: "step1",
    step2: "step2",
    step3: "step3",
    text_01: "Note: this qr code and key is the unique identification of the Google verification code, please do not leak it.",
    text_02: "Use the Google validator to scan the qr code or enter the following key",
    text_03: "Some android phones do not support scanning qr code, please select the key input method",
    text_04: "Fill in the information below to enable Google authentication",

  },
  // 支付绑定
  pay: {
    Payment: 'Payment of the binding',
    bank: 'Bank',
    bCard: 'Bank card',
    change: 'change',
    confirm: 'confirm',
    addBank: "Add",
    account: "Account",
    weixin: "WeChat",
    alipay: "Alipay",
    bankCard: "Bank Card",
    delete: "Delete",
    default: "Default",
    setDefault: "Set Default",
    branch: "Branch",
    text_01: "Please complete the real-name authentication first",
    text_02: "Bank card has not been bound yet",
    text_03: "Are you sure to delete this card?",
    text_04: "Are you sure to set it as the default card?",
    text_05: "Confirm shutdown?",
    text_06: "Payment methods",

    goCertification: "Go certification",
  },
  // 验证方式
  vmode: {
    vmode: 'verification mode',
    Passauth: 'password authentification',
    gauth: 'Google authentication',
    eauth: 'mailbox verification',
    mauth: 'SMS verification'
  },
  // 绑定手机
  bmobile: {
    bmobiles: 'Binding mobile phone',
    mnumber: 'cell phone number',
    pnum: 'Please enter your mobile phone number',
    mauth: 'message authentication code',
    correctnum: "Please enter the correct mobile phone number",
    gcode: 'get code',
    again: ' Refetch after seconds',
    unbind: 'unbind',
    submit: 'submit'
  },
  // 搜索
  search: {
    antistop: 'Please enter keywords',
    search: 'search'
  },
  // 关注货币
  currency: {
    attention: 'Currency concerns',
    noattention: 'No currency concerns',
    currencyname: 'Enter currency name for real-time filtering',
    acurrency: 'Focus on the currency',
    kind: 'kind'
  },
  // 身份验证
  showDialogs: {
    authentication: "authentication",
    password: 'password',
    ppass: 'enter your PIN',
    gauth: 'Google verification code',
    pgauth: 'Please enter the Google verification code',
    eauth: 'Mailbox verification code',
    peauth: 'Please enter the email verification code',
    mauth: 'cell phone verification code',
    pmauth: 'Please enter the mobile phone verification code',
    code: "code",
    pcode: "Please enter the verification code",
  },
  // 提币
  withdrawto: {
    address: 'Address name, such as: my address 1, optional',
    depositprice: 'cash withdrawal amount',
    inputprice: 'Please enter the amount',
    usableprice: 'available',
    withdraw: "withdraw",
    available: "available",
    cancel: "cancel",
    withdrawAddress: "Address",
    withdrawAmount: "Amount",
    newAddress: "Add new address",
    text_01: "Click add withdrawal address",
    text_02: "The withdrawal address cannot be empty",
    text_03: "Please select",
    text_04: "Are you sure to delete this address?",
    text_05: "The chain name cannot be empty",
    actual: "Actual",
    cannotbezero: "Cannot be zero",
    minWithdrawal: "Minimum withdrawal",
    codenull: "Please enter the verification code",
    addAddress: "Add the withdrawal address",
    mindeposit: 'Minimum withdrawal:',
    fee: 'Fee',
    sure: 'confirm',
    deposit: 'Mention money',
    or: 'or',
    taccounts: 'transfer accounts',
    pinput: 'Please input.',
    add: "Add",
    edit: "Edit",
    code: "code",
    getCode: "Get Code",
    resend: " Refetch after seconds",
    prompt: "prompt",
    deleteSuccess: "Delete the success",
    EditSuccess: "Edit success",
    addSuccess: "Add success",
    AddressNote: "Address note",
    depositadd: 'Withdrawal address',
    raccount: 'opposite money',
    depositsuccess: 'Withdrawal success',
    addnull: 'Address or withdrawal amount cannot be empty',
    passerr: 'wrong password',
    gerr: 'Google verification code error'
  },
  // 充值
  payto: {
    qrcode: 'Recharge to the qr code address',
    copy: 'copy',
    sweepcode: 'Scan qr code',
    getadd: 'Gets the recharge address',
    inputrecharge: 'Please enter the recharge amount',
    sure: 'Confirm',
    hint: 'Enter the amount to recharge and filter the agent with sufficient funds (contact the agent through the following contact information to recharge for you)',
    Rechargedefeated: 'Top-up failure',
  },
  // 充值提现记录
  bill: {
    record: 'Recharge and withdraw records',
    allrecord: 'complete documentation',
    rechargeRecord: 'recharge record',
    withdrawRecord: 'Withdrawal record',
    ToAudit: 'To audit',
    error: 'error',
    pulldown: 'Click down to see more',
    nodata: 'Theres no more data',
    loading: 'Loading in...'
  },
  lock: {
    time: "Time",
    lockName: "Lock Name",
    coin: "Coin",
    lockAmount: "Amount",
    lockValue: "Lock Value",
    status: "Status",
    action: "Action",
    add: "Add",
    upgrade: "upgrade",
    selectLock: "Select Lock",
    status_01: "ongoing",
    status_02: "complete",
    lock: "Lock",
    lockRules: "Lock Rules"
  },
  // 游戏
  game: {
    game: 'game',
    gameTips: 'fairness 100%',
    available: "available",
    rollDice: 'roll dice',
    becomeDealer: 'become a dealer',
    introduce: 'introduction to play',
    currentCoin: 'current currency',
    bettingAmount: 'bet amount',
    winningAmount: 'winning amount',
    winVictory: 'win',
    point: 'points',
    odds: 'odds',
    winningProbability: 'winning probability',
    user: 'user',
    luckyNumber: 'number',
    reward: 'reward',
    allBets: 'all bets',
    myBet: 'my bet',
    beADealer: 'be A Dealer',
    bonusPool: 'bonus pool',
    currentInvestment: 'current investment',
    bettingRatio: 'proportion of bets',
    investedCoin: 'invested currency',
    investment: 'investment',
    withdrawalCoin: 'withdraw currency',
    step1: '1. Select the currency to be bet',
    step2: '2. Set the required bet amount',
    step3: '3. Adjust the position of the slider on the slider, and change the number range of the stake to change the winning probability',
    step4: '4. Press the "bet" button to make a bet. If the number is within the range of the number, win the prize immediately',
    moreThanBalance: 'cannot exceed balance ',
    moreThanBets: 'cannot be greater than the maximum bet ',
    minimumbet: "Cannot be less than minimum bet ",
    win: 'wins',
    lost: 'lose',
    withdrawal: 'withdraw',
    investmentSuccess: 'investment success',
    divestmentSuccess: 'divestment succeeded',
    bet: "bet",
    profit: "profit",
    random: "Random",
    dealer: "Dealer",
    rule: "Rule",
    website: "website",
    my: "my",
    rettingRecord: "Betting record",
    AllBets: "All bets",
    myBets: "my bets",
    betInfo: "Betting information",
    serverSeed: "Server seed",
    hash: "(hash)",
    customerSeed: "customer seed",
    randomNumber: "random number",
    multiple: "multiple",
    serverHash: "Server side seed hash",
    scope: "scope",
    serialNumber: "Serial number",
    change: "Change",
    changeSuccess: "Change success",
    NotReleased: "Not released",
    fair_01: "1. The game can be reversely verified by the mathematical formula that each random roll is fair, and the operator cannot pre-determine the outcome.",
    fair_02: "2. When you press the 'change your luck' button in the user menu bar, the system will generate a set of server random seed SHA256 hash value, and then with the customer set the customer random seed, and betting stream number, we will combine the above three data operation, to produce a fair and random betting results."
  },
  // 炒币机器人
  financial: {
    old: "Old",
    new: 'New',
    profitTop: "Profit Top",
    dayStatistics: "Daily income data statistics",
    returnsDetailed: "Returns Detailed",
    coinTop: "Coin Top",
    bigData: "Quantize Big Data",
    day: "Day",
    month: "Month",
    all: "All",
    total: "Total",
    my: "My",
    pair: "Market",
    uid: "UID",
    freeze: "Freeze",
    destroy: "Destroy",
    discuss: "Discuss",
    available: "Available",
    totalStatistics: " Total Statistics",
    dayProfit: "Day Profit",
    quantize: "Quantize",
    totalRevenue: " Total Revenue",
    totalYield: " Total Yield",
    fullscreen: "Fullscreen",
    exitFullscreen: "Exit Fullscreen",
    platform: "All",
    financial: "Financial",
    EquipmentBind: "Equipment bind:",
    help: "Help",
    IsBinding: "Is binding",
    AddRobot: "Add robot",
    text_01: "Please log in the APP to bind!",
    RobotList: "Robot list",
    grossProfit: "gross profit",
    IncomeRanked: "Income ranked",
    market: "market",
    buy: "Have to buy",
    revenue: "revenue",
    Operations: "Operations",
    grade: "grade",
    user: "user",
    bet: "bet",
    profit: "Profit",
    delete: "delete",
    edit: "edit",
    stop: "Stop",
    start: "Start",
    add: "add",
    robot: " robot",
    exchange: "exchange",
    setSuccess: "set success",
    robotResult: "Robot result",
    robotHistory: "Robot history",
  },
  recommended: {
    title: "Will recommend to your friend",
    history: "History",
    text_01: "For each user you recommend, we will reward you, see the specific reward announcement.",
    text_02: "We will generate a separate link for you that you can share with your friends for registration. The system will identify the user who registered with this link as your recommendation.",
    text_03: "It is not allowed to spread any misleading information or do any harm",
    text_03_1: "Brand behavior.",
    text_04: "We will freeze any accounts that abuse this referral system without prior notice.",
    text_05: "You have read and agreed to our terms and conditions of use",
    account: "Account",
    reward: "Reward",
    addHistory: "Add History",
    bonusHistory: "Bonus History",
    referrerUid: "Referrer Uid",
    status: "Status",
    status_01: "In account",
    status_02: "Not in account",
  },
  // 币种介绍
  introduces: {
    coinIntroduction: "Coin introduction",

    link: "Link",

    parameter: "Parameter",
    ChineseName: "Chinese name",

    EnglishName: "English name",

    EnglishAbbreviation: "English abbreviation",

    Developer: "Developer",

    BlockTime: "Block time",

    DateIssue: "Date of issue",

    CoreAlgorithm: "Core algorithm",

    MonetaryAggregates: "Monetary aggregates",

    whitePaper: "White paper",

  },
  // 工单
  workOrder: {
    title: "Title",
    type: "Type",
    createTime: "Create time",
    state: "State",
    operation: "Operation",
    view: "View",
    close: "Close",
    create: "Create work order",
    content: "Content",
    text_03: "Can't be empty",
    text_02: "Only JPG/PNG/BMP/GIF files can be uploaded",
    text_01: "Please describe your problem specifically and accurately, which will help us to help you more efficiently!",
    upload: "upload attachments",
    complete: "complete",
    processing: "processing",
    pending: "pending",
  },
  "SUCCESS": "Success",
  "PERMISSION_DENIED": "Permission denied",
  "SEND_CODE_TOO_FAST": "Send verification code too fast",
  "OPERATION_TOO_FAST": "Operating too fast",
  "CODE_HAS_SEND": "Code has send",
}



// WEBPACK FOOTER //
// ./src/common/language/en.js